import { TeiaSearchOperator, ApiClient } from '@stereograph/teia-system-design/utils';

export interface Alias {
  name: string;
  alias: {
    data_sources: Array<DataSource>;
  };
}

export interface CompleteAlias extends Alias {
  id: string;
}

export interface BaseDataSource {
  operator?: TeiaSearchOperator;
  value?: string;
  value_type: 'string' | 'number' | Array<string>;
}

export interface BimData extends BaseDataSource {
  type: 'bim_data';
  prop: string;
  name: string;
}

export interface OpenData extends BaseDataSource {
  type: 'open_data';
  key: string;
}

export interface UserData extends BaseDataSource {
  type: 'user_data';
  app_name: string;
  name: string;
}

export type DataSource = BimData | OpenData | UserData;

export const TiaAliasTableApi = (client: ApiClient) => ({
  createAliasTable(alias: Alias) {
    const url = client.URL('alias_table');
    const data = JSON.stringify(alias);

    const request = new Request(url, {
      method: 'POST',
      body: data,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return client.sendRequest<CompleteAlias>(request);
  },

  updateAliasTable(alias: Alias, id: string) {
    const url = client.URL(`alias_table/${id}`);
    const data = JSON.stringify(alias);

    const request = new Request(url, {
      method: 'PATCH',
      body: data,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return client.sendRequest<CompleteAlias>(request);
  },

  getAllAliasTables() {
    const url = client.URL('alias_table');
    const request = new Request(url, {
      method: 'GET',
    });

    return client.sendRequest<Array<CompleteAlias>>(request);
  },

  deleteAliasTable(id: string) {
    const url = client.URL(`alias_table/${id}`);
    const request = new Request(url, {
      method: 'DELETE',
    });

    return client.sendRequest(request);
  },

  getAliasInputJsonSchema() {
    const url = client.URL('alias_table/alias_input_schema');
    const request = new Request(url, {
      method: 'GET',
    });

    return client.sendRequest<any>(request);
  },
});
